import { useCallback, useMemo } from 'react'

import { useToast } from '@driftt/dds'

/**
 * Returns functions to notify the user of success, info, or error
 * @returns {object} { error: (message) => void,  info: (message) => void, success: (message) => void }
 */
const useNotifications = () => {
  const triggerToast = useToast()

  const success = useCallback(
    (message) =>
      triggerToast({
        message: message,
        variant: 'success',
      }),
    [triggerToast]
  )

  const info = useCallback(
    (message) =>
      triggerToast({
        message: message,
        variant: 'info',
      }),
    [triggerToast]
  )

  const error = useCallback(
    (message) =>
      triggerToast({
        message: message,
        variant: 'error',
      }),
    [triggerToast]
  )

  return useMemo(() => ({ success, info, error }), [error, info, success])
}

export default useNotifications
